import { useTranslation } from 'react-i18next'

import { Col, Modal, Row } from 'common/components'

import { formatMoneyIntegers } from '../../../common'
import { ExpenseTotals } from './index'

type HSASuccessModalProps = {
  handleSuccessModalClose: () => void
  expenseTotals: ExpenseTotals
}

const HSASuccessModal = ({ handleSuccessModalClose, expenseTotals }: HSASuccessModalProps) => {
  const { t: translate } = useTranslation()

  return (
    <Modal visible onOk={handleSuccessModalClose} onCancel={handleSuccessModalClose} closable>
      <Row>
        <Col span={24} className="outline-green mt-24 mb-16 p-8">
          <i className="fas fa-check primary-color p-16" />
          <span className="pl-16">
            {translate('admin-dashboard.manage-people.view-employee.benefit-history.hsa-success-update.title')}
          </span>
        </Col>
      </Row>
      <Row className="text-center mb-16 mt-8 ">
        <Col span={24}>
          <span className="font-20">
            {translate('admin-dashboard.manage-people.view-employee.benefit-history.hsa-success-update.content.title')}
          </span>
        </Col>
      </Row>
      <Row className="mb-16 mt-8">
        <Col span={24}>
          <span className="font-14">
            {translate('admin-dashboard.manage-people.view-employee.benefit-history.hsa-success-update.content.body')}
          </span>
        </Col>
      </Row>
      <Row className={'text-center mb-16 mt-16'}>
        <Col span={24}>
          <span className="font-20">
            {translate(
              'admin-dashboard.manage-people.view-employee.benefit-history.hsa-success-update.content.sub-header',
            )}
          </span>
        </Col>
      </Row>
      <Row className={'text-center mb-16 mt-16'}>
        <Col span={12}>
          <Row>
            <Col>
              <span className="large-font-size text-semi-bold">{expenseTotals.expenseCount}</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="font-16">
                {translate(
                  'admin-dashboard.manage-people.view-employee.benefit-history.hsa-success-update.content.expense',
                )}
              </span>
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row>
            <Col>
              <span className="large-font-size text-semi-bold">
                {formatMoneyIntegers(expenseTotals.totalAmount, true)}
              </span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="font-16">
                {translate(
                  'admin-dashboard.manage-people.view-employee.benefit-history.hsa-success-update.content.total',
                )}
              </span>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className={'mb-16 mt-16'}>
        <Col span={24}>
          <span className="font-14">
            {translate('admin-dashboard.manage-people.view-employee.benefit-history.hsa-success-update.content.footer')}
          </span>
        </Col>
      </Row>
      <Row className={'m-8'}>
        <Col span={24}>
          <a href={'https://www.peoplekeep.com/health-savings-accounts'} target="_blank">
            <i className="fas fa-info-circle"></i>
            {translate('admin-dashboard.manage-people.view-employee.benefit-history.hsa-success-update.content.info')}
          </a>
        </Col>
      </Row>
    </Modal>
  )
}

export default HSASuccessModal
